import React, { createContext, useContext, useEffect, useMemo } from "react";

const PlatformDashboardContext = createContext(null);

export function PlatformDashboardProvider({ children, value }) {
  const memo = useMemo(
    () => ({
      variant: "platform",
      enabled: Boolean(value?.enabled),
      liveEnabled: Boolean(value?.liveEnabled),
      surveysEnabled: Boolean(value?.surveysEnabled),
      dominioIds: Array.isArray(value?.dominioIds) ? value.dominioIds : [],
      workspaces: Array.isArray(value?.workspaces) ? value.workspaces : [],
    }),
    [value?.enabled, value?.liveEnabled, value?.surveysEnabled, value?.dominioIds, value?.workspaces]
  );

  return <PlatformDashboardContext.Provider value={memo}>{children}</PlatformDashboardContext.Provider>;
}

export function usePlatformDashboardContext() {
  return useContext(PlatformDashboardContext);
}
